import { HTML, ID, IPost } from "@libs/interfaces/layouts"
import { __ } from "src/libs/utilities"

import { default as UUID } from "node-uuid"

export interface IPETestCategory extends IPost {

}
export interface IPETest extends IPost {
    is_show_answer: boolean
    is_show_results?: boolean
    is_shuffle?: boolean
    is_timed?: boolean
    auth_type?: PE_TEST_AUTH_TYPE
    finish_view_type?: FINISH_VIEW_TYPE
    duration?: number
    try_count: number
    publish_type?: PE_TEST_PUBLISH_TYPE
    questions: PETestQuestion[]
    testCategory?: IPETestCategory
    pe_academic_discipline : any[], // IAcademicDiscipline[]
    pe_test_category?: any[]
    finish_message?: HTML
}
export enum PE_TEST_PUBLISH_TYPE {
    STANDART="STANDART",
    ELECTRONIC_COURSE="ELECTRONIC_COURSE",
    INTRAMURAL_COURSE="INTRAMURAL_COURSE",
}
export enum PE_TEST_AUTH_TYPE {
    NONE,
    AUTH,
    ANONYM
    
}
export enum FINISH_VIEW_TYPE {
    NONE,
    SHOW_RESULT,
    MESSAGE
    
}
export interface PETestQuestion extends IPost {
    answers: PETestQuestionAnswer[]
    right_answer_id: ID
    hidden?: boolean
    hardness?: number
    is_deleted?: boolean
    single: boolean
    type: PE_TEST_QUESTION_TYPE
    penalty?: string
    test? : IPETest
    pe_test_category?: any[]

}
export enum PE_TEST_QUESTION_TYPE {
    MULTI_CHOOSE="MULTI_CHOOSE",
    TRUE_FALSE="TRUE_FALSE",
    MATCHING="MATCHING",
    RANGE="RANGE"
    
}
export interface PETestQuestionAnswer extends IPost {
    question?: PETestQuestion
    is_deleted?: boolean
    is_subquestion: boolean
    subquestion_answer?: PETestQuestionAnswer
    order: number
    pe_test_category?: any[]
}

export enum TEST_CURRENT_MODE {
    START="START",
    FOLLOW="FOLLOW",
    FINISH="FINISH",
    GET_RESULTS="GET_RESULTS",
}

export const defaultTest = (): IPETest => {
    return {
        id: UUID.v4(),
        title: __("New Test"),
        post_content:"",
        questions: [],
        is_show_answer: false,
        try_count: 0,
        pe_academic_discipline : [{
            id: 1111111111,
            title: "Test discipline",
            post_content: "",
            order: -1,
            color: "#C60000"
        }]
    }
}